export default __webpack_public_path__ + "static/media/raisut.6c41e66d.png";